import { render, staticRenderFns } from "./SkillsWidget.vue?vue&type=template&id=38ed6dde&scoped=true"
import script from "./SkillsWidget.vue?vue&type=script&lang=js"
export * from "./SkillsWidget.vue?vue&type=script&lang=js"
import style0 from "./SkillsWidget.vue?vue&type=style&index=0&id=38ed6dde&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ed6dde",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38ed6dde')) {
      api.createRecord('38ed6dde', component.options)
    } else {
      api.reload('38ed6dde', component.options)
    }
    module.hot.accept("./SkillsWidget.vue?vue&type=template&id=38ed6dde&scoped=true", function () {
      api.rerender('38ed6dde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/views/rh/dashboard/widgets/SkillsWidget.vue"
export default component.exports